(function () {
  const initEventsSlider = () => {
    const focusableSelector =
      'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]';

    document.querySelectorAll('[data-events-slider]').forEach((slider) => {
      const track = slider.querySelector('[data-events-track]');
      const viewport = track ? track.parentElement : null;
      const slides = Array.from(slider.querySelectorAll('[data-events-slide]'));
      if (!track || slides.length === 0) return;

      const perViewSetting = parseInt(slider.getAttribute('data-slides-per-view'), 10) || 3;
      const resolvePerView = () => {
        if (window.matchMedia('(max-width: 639px)').matches) return 1;
        if (window.matchMedia('(max-width: 1023px)').matches) return Math.min(2, perViewSetting);
        return Math.max(1, Math.min(perViewSetting, slides.length));
      };

      let perView = resolvePerView();
      let index = 0;
      const dotsWrap = slider.querySelector('[data-events-dots]');
      let dots = [];

      const maxIndex = () => Math.max(0, slides.length - perView);
      const clamp = (val) => Math.max(0, Math.min(val, maxIndex()));

      const updateSlideAccessibility = () => {
        const start = index;
        const end = index + perView;

        slides.forEach((slide, slideIndex) => {
          const isVisible = slideIndex >= start && slideIndex < end;
          slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');

          slide.querySelectorAll(focusableSelector).forEach((el) => {
            if (isVisible) {
              if (el.hasAttribute('data-a11y-tabindex')) {
                const original = el.getAttribute('data-a11y-tabindex');
                if (original === '') {
                  el.removeAttribute('tabindex');
                } else {
                  el.setAttribute('tabindex', original);
                }
                el.removeAttribute('data-a11y-tabindex');
              }
              return;
            }

            if (!el.hasAttribute('data-a11y-tabindex')) {
              el.setAttribute('data-a11y-tabindex', el.getAttribute('tabindex') ?? '');
            }
            el.setAttribute('tabindex', '-1');
          });
        });
      };

      const updateDots = () => {
        if (!dotsWrap || dots.length === 0) return;
        dots.forEach((dot, i) => {
          const isActiveDot = i === index;
          dot.classList.toggle('bg-gray-900', isActiveDot);
          dot.classList.toggle('bg-gray-300', !isActiveDot);
          dot.classList.toggle('w-6', isActiveDot);
          dot.setAttribute('aria-current', isActiveDot ? 'true' : 'false');
        });
      };

      const buildDots = () => {
        if (!dotsWrap) return;
        dotsWrap.setAttribute('role', 'group');
        dotsWrap.setAttribute('aria-label', 'Event slider navigation');
        dotsWrap.innerHTML = '';

        dots = Array.from({ length: maxIndex() + 1 }).map((_, i) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'h-2 w-2 theme-border-radius bg-gray-300 transition';
          btn.setAttribute('aria-label', `Go to event group ${i + 1}`);
          btn.addEventListener('click', () => {
            index = i;
            update();
          });
          dotsWrap.appendChild(btn);
          return btn;
        });
        updateDots();
      };

      const getGap = () => {
        const gap = parseFloat(window.getComputedStyle(track).gap || '0');
        return Number.isFinite(gap) ? gap : 0;
      };

      const getSlideWidth = () => {
        const first = slides[0];
        if (!first) return 0;
        const rect = first.getBoundingClientRect();
        return rect.width || 0;
      };

      const update = () => {
        index = clamp(index);
        const offset = index * (getSlideWidth() + getGap());
        const maxOffset = viewport ? Math.max(0, track.scrollWidth - viewport.clientWidth) : offset;
        track.style.transform = `translateX(-${Math.min(offset, maxOffset)}px)`;
        updateSlideAccessibility();
        updateDots();
      };

      const applyWidths = () => {
        perView = resolvePerView();
        const width = 100 / perView;
        slides.forEach((slide) => {
          slide.style.width = `${width}%`;
        });
        update();
        buildDots();
      };

      const prev = slider.querySelector('[data-events-prev]');
      const next = slider.querySelector('[data-events-next]');
      if (prev) {
        prev.addEventListener('click', () => {
          index -= 1;
          update();
        });
      }
      if (next) {
        next.addEventListener('click', () => {
          index += 1;
          update();
        });
      }

      applyWidths();
      window.addEventListener('resize', applyWidths);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEventsSlider);
  } else {
    initEventsSlider();
  }
})();
